module.exports = __webpack_public_path__ + "static/media/bg.6ece7924.png";